// Import modules either as named imports (preferred method) or as a default import.
import Player from '@3pc/player-videojs';
import { ConsentOverlay } from '@3pc/consent-overlay';
import { $, $$ } from '@3pc/dom';

// vimeo or youtube videos that require a consent overlay.
const overlays = $$('.teaser-video [data-consent-type]');
if (overlays.length) {
  overlays.forEach(overlay => {
    // Select the player element and configure player settings.
    const playerEl = $('.player', overlay);

    // stop here if player element is missing
    if (!playerEl) return;

    // Create a new Player instance with the specified element and configuration.
    const player = new Player({
      player: playerEl,
    });

    new ConsentOverlay({
      container: overlay,
      nameSpace: 'Teddy Awards',
      onActivation: () => player.init(),
      onDeactivation: () => player.destroy(),
    }).init();
  });
}

// MP4 videos that do not require a consent overlay.
const videoSrcs = $$('.teaser-video__video');
if (videoSrcs.length) {
  videoSrcs.forEach(videoSrc => {
    // Create a new Player instance with the specified element and configuration.
    return new Player({
      player: videoSrc,
    }).init();
  });
}
